module.exports = __webpack_public_path__ + "static/DFS_CA_Tools_Calendars-c0728560d3307a50efd2fd102fd76b79.jpg";